import type { FC } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";

const bulletPointKeys: Array<string> = [
    "llm.loading-banner.bullet.1",
    "llm.loading-banner.bullet.2",
    "llm.loading-banner.bullet.3",
    "llm.loading-banner.bullet.4",
];

export const ReportLoadingBanner: FC = () => (
    <Flex
        data-automation="report-loading-banner"
        justifyContent="center"
        padding="0 24px"
        borderRadius="6px"
        margin="0 0 8px"
        background={colorsPalettes.carbon[0]}
        border={`1px solid ${colorsPalettes.midnight[50]}`}
    >
        <Flex
            justifyContent="center"
            alignItems="center"
        >
            <img
                width="230px"
                src={AssetsService.assetUrl("/images/ai-tagging/copilotloader.webp")}
                alt=""
            />
            <Flex
                justifyContent="center"
                alignItems="center"
            >
                <Flex
                    flexDirection="column"
                    gap="12px"
                >
                    <Text
                        fontVariant="subtitle1"
                        color={colorsPalettes.carbon[500]}
                    >
                        {translate("llm.loading-banner.title")}
                    </Text>
                    <Flex
                        flexDirection="column"
                        gap="8px"
                    >
                        {bulletPointKeys.map((key) => (
                            <Flex
                                key={key}
                                alignItems="center"
                                gap="8px"
                            >
                                <SWReactIcons
                                    iconName="checked"
                                    size="xs"
                                    iconColor={colorsPalettes.carbon[400]}
                                />
                                <Text
                                    fontVariant="caption"
                                    color={colorsPalettes.carbon[400]}
                                >
                                    {translate(key)}
                                </Text>
                            </Flex>
                        ))}
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    </Flex>
);
